const requiredMonthlyDemands = [{
        id : "mdsi1",
        year1ActualDemands : [80,85,80,110,115,120,100,120,85,75,85,75],
        year2ActualDemands : [100,75,90,85,130,110,115,90,110,85,75,70]
    },
    {
        id : "mdsi2",
        year1ActualDemands : [80,85,80,110,115,120,100,120,85,75,85,75],
        year2ActualDemands : [100,75,90,85,130,110,115,90,110,85,75,70]
    },
    {
        id : "mdsi3",
        year1ActualDemands : [80,85,80,110,115,120,100,120,85,75,85,75],
        year2ActualDemands : [100,75,90,85,130,110,115,90,110,85,75,70]
    },
    {
        id : "mdsi4",
        year1ActualDemands : [80,85,80,110,115,120,100,120,85,75,85,75],
        year2ActualDemands : [100,75,90,85,130,110,115,90,110,85,75,70]
    },
    {
        id : "mdsi5",
        year1ActualDemands : [80,85,80,110,115,120,100,120,85,75,85,75],
        year2ActualDemands : [100,75,90,85,130,110,115,90,110,85,75,70]
    },
]

const prevYearLastMonthActualDemand = 70;
const prevYearLastMonthEXP_2 = 75;
const prevYearLastMonthEXP_5 = 75;

const seasonalIndex = [0.954,
    0.848,
    0.901,
    1.033,
    1.298,
    1.219,
    1.139,
    1.113,
    1.033,
    0.848,
    0.848,
    0.768
]

export {requiredMonthlyDemands, seasonalIndex, prevYearLastMonthActualDemand, prevYearLastMonthEXP_2, prevYearLastMonthEXP_5};